export class RepReportModel{
    data:any[];

    constructor(){}
}